import { CircularProgress } from '@mui/material';

import { BackdropLoadingBase } from './BackdropLoading.styles';

const BackdropLoading = () => {
  return (
    <BackdropLoadingBase open={true} data-testid="backdrop-component">
      <CircularProgress
        color="inherit"
        data-testid="circular-progress-component"
      />
    </BackdropLoadingBase>
  );
};

export default BackdropLoading;
